// src/components/LangSwitcher.jsx
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAnalytics } from "../hooks/useAnalytics";

export default function LangSwitcher() {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { trackLanguageSwitch } = useAnalytics();

  const switchTo = (target) => {
    if (target === lang) return;
    trackLanguageSwitch(lang, target);
    localStorage.setItem("lang", target);
    const nextPath = location.pathname.replace(/^\/(it|en)/, `/${target}`);
    navigate(nextPath + location.search + location.hash, { replace: false });
  };

  return (
    <div role="group" aria-label="Language switch" style={{ display: "flex", gap: 8 }}>
      <button
        aria-pressed={lang === "it"}
        onClick={() => switchTo("it")}
        className={lang === "it" ? "btn-active" : "btn"}
      >
        IT
      </button>
      <button
        aria-pressed={lang === "en"}
        onClick={() => switchTo("en")}
        className={lang === "en" ? "btn-active" : "btn"}
      >
        EN
      </button>
    </div>
  );
}
